//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import {
  InputField,
  Label,
  FormGroup,
  Error,
  FormRow,
  FormCol,
  Note
} from "../UI/Form"
import { PrimaryButton, SecondaryButton } from "../UI/Buttons"
import validate from "./validate"
import type { SensorFormProps } from "./types"

const SensorForm = ({
  handleSubmit,
  handleCancel,
  handleChange,
  handleDelete,
  sensors,
  attractLoops,
  error,
  pristine,
  id
}: SensorFormProps) =>
  <form onSubmit={handleSubmit}>
    <Note>NOTE: Only "friendly name" can be modified.</Note>
    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="friendlyName">Friendly Name</Label>
          <Field
            name="friendlyName"
            component={InputField}
            type="text"
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note>A Name that will help you easily identify this sensor</Note>
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="stationName">Station Name</Label>
          <Field
            name="stationName"
            component={InputField}
            type="text"
            onChange={handleChange}
            disabled={true}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="serialNumber">Serial Number</Label>
          <Field
            name="serialNumber"
            component={InputField}
            type="text"
            onChange={handleChange}
            disabled={true}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="sim">SIM</Label>
          <Field
            name="sim"
            component={InputField}
            type="text"
            onChange={handleChange}
            disabled={true}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="environmental">Environmental</Label>
          <Field
            name="environmental"
            component={InputField}
            type="text"
            onChange={handleChange}
            disabled={true}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    <FormRow>
      <FormCol grow={2}>
        <FormRow>
          <FormCol grow={2}>
            <FormGroup>
              <Label htmlFor="latitude">Latitude</Label>
              <Field
                name="latitude"
                component={InputField}
                type="text"
                onChange={handleChange}
                disabled={true}
              />
            </FormGroup>
          </FormCol>
          <FormCol grow={2}>
            <FormGroup>
              <Label htmlFor="latitude">Longitude</Label>
              <Field
                name="longitude"
                component={InputField}
                type="text"
                onChange={handleChange}
                disabled={true}
              />
            </FormGroup>
          </FormCol>
        </FormRow>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>

    {error &&
      <Error>
        {error}
      </Error>}

    <FormRow>
      <FormCol grow={2}>
        <FormRow>
          <FormCol grow={1} />
          <FormCol grow={1}>
            <SecondaryButton block={true} onClick={handleCancel}>
              Cancel
            </SecondaryButton>
          </FormCol>
          <FormCol grow={1}>
            <PrimaryButton block={true} disabled={pristine}>
              Update Sensor
            </PrimaryButton>
          </FormCol>
        </FormRow>
      </FormCol>
      <FormCol grow={1}>
        <Note />
      </FormCol>
    </FormRow>
  </form>

export default reduxForm({
  form: "sensor",
  enableReinitialize: true,
  validate
})(SensorForm)



// WEBPACK FOOTER //
// ./src/Sensors/SensorForm.js